import { AuthSettingsService } from '../services/auth';

export function AuthInitializerFactory(authSettingsService: AuthSettingsService) {
    return async (): Promise<void> => {
        // Load auth settings
        await authSettingsService.initializeAuth();
    };
}
